<template>
  <div ref="rowInfo" class="f-row-info">
    <div class="f-row-info-container pr-5">
      <XIcon class="close" @click="close"/>

      <p><strong>id: </strong>{{ row.id }}</p>
      <p v-if="publicTable">
        <strong>url: </strong>
        <a :href="rowUrl" target="_blank">{{ rowUrl }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

const clickOutside = (element, callback) => {
  document.addEventListener('click', event => {
    const isClickInside = element.contains(event.target)
    if (!isClickInside) callback()
  })
}

const domain = {
  production: 'https://custom-table.platform.brobot.com.br',
  staging: 'https://custom-table.platform-staging.brobot.com.br',
}[process.env.VUE_APP_ENV] || 'http://localhost:3001'

export default {
  components: { XIcon },
  computed: {
    publicTable() {
      return this.table.public
    },
    rowUrl() {
      return `${domain}/v1/public_tables/${this.table.uuid}/rows/${this.row.id}`
    }
  },
  data: () =>({
    load: false
  }),
  methods: {
    close() {
      this.$emit('closed')
    },
  },
  mounted() {
    setTimeout(() => {
      clickOutside(this.$refs.rowInfo, () => this.close())
    }, 1)
  },
  name: 'FieldInfo',
  props: {
    row: {
      required: true,
      type: Object
    },
    table: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>
.f-row-info {
  position: absolute;
  background-color: white;
  white-space: nowrap;
  top: 0;
  right: 0;
  padding: 8px 16px;
  z-index: 2;
  border-radius: 4px;
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
  overflow: auto;
}

.f-row-info-container {
  position: relative;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
</style>